var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_1987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2158 43.3151L47.1379 51.9802L8.80357 88.5661C7.79717 89.5289 6.50615 90.0103 5.21512 90.0103C3.80211 90.0103 2.3891 89.4367 1.36237 88.2998C-0.660574 86.0669 -0.396269 82.5743 1.93164 80.6692L47.1379 43.8272L52.119 39.7712L56.2158 43.3151Z",
    fill: "url(#paint0_linear_306_1987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7414 52.4206L37.8058 60.9423L36.9824 52.185L41.8721 48.2007L46.7414 52.4206Z",
    fill: "#3A81D6",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9782 29.9078C91.9782 46.4288 78.6817 59.8259 62.2948 59.8259C51.9666 59.8259 42.8684 54.5101 37.5518 46.4391C34.431 41.7071 32.6113 36.0225 32.6113 29.9078C32.6113 13.3868 45.9079 0 62.2948 0C69.6953 0 76.4554 2.72448 81.65 7.23114C87.973 12.7211 91.9782 20.8433 91.9782 29.9078Z",
    fill: "url(#paint1_linear_306_1987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2946 53.2093C75.0671 53.2093 85.4213 42.7768 85.4213 29.9078C85.4213 17.0387 75.0671 6.60632 62.2946 6.60632C49.5221 6.60632 39.168 17.0387 39.168 29.9078C39.168 42.7768 49.5221 53.2093 62.2946 53.2093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M91.9782 29.9078C91.9782 46.4288 78.6816 59.8259 62.2947 59.8259C51.9665 59.8259 42.8683 54.5101 37.5518 46.4391C71.027 43.6941 79.8507 15.1178 81.6601 7.23114C87.9729 12.7211 91.9782 20.8433 91.9782 29.9078Z",
    fill: "#1A6FB5",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2944 29.959C64.9782 29.959 67.1536 27.7672 67.1536 25.0632C67.1536 22.3592 64.9782 20.1673 62.2944 20.1673C59.6107 20.1673 57.4353 22.3592 57.4353 25.0632C57.4353 27.7672 59.6006 29.959 62.2944 29.959ZM62.2944 32.407C59.0516 32.407 52.5762 34.0458 52.5762 37.3028V38.5319C52.5762 39.2079 53.1251 39.761 53.796 39.761H70.8132C71.4841 39.761 72.0331 39.2079 72.0331 38.5319V37.3028C72.0127 34.056 65.5373 32.407 62.2944 32.407Z",
    fill: "url(#paint2_linear_306_1987)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_1987",
    x1: 5.6749,
    y1: 84.3265,
    x2: 53.9246,
    y2: 40.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_1987",
    x1: 50.0175,
    y1: 2.11336,
    x2: 72.782,
    y2: 52.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_1987",
    x1: 55.2685,
    y1: 28.3947,
    x2: 72.9194,
    y2: 36.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071077,
    stopColor: "#A6F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2937,
    stopColor: "#8BE8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5209,
    stopColor: "#78E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_1987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.978,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.150f14afe817722fcb204005d6fbc6ce.svg";
export { ForwardRef as ReactComponent };